import Base from './Base';

export default class extends Base {
    _element;

    constructor(element) {
        super();
        if (element instanceof jQuery) {
            this.setElement(element);
        }
    }

    setElement(element) {
        this._element = element;
        this._element.data('instance', this);
        this.setWrapper(element);
    }

    getElement() {
        return this._element;
    }

    datamodel() {
        return this._element.datamodel();
    }

    hasDatamodel() {
        return !!this.datamodel();
    }

    panel() {
        return this._element.panel();
    }

    snapgrid(name) {
        return this._element.snapgrid(name);
    }

    vueApp(name) {
        return this._element.vueApp(name);
    }

    context() {
        return this._element.context();
    }

    runFunction(func, ...params) {
        if (typeof this[func] === 'function') {
            return this[func](...params);
        }
    }
}
